import { Quote, Star } from 'lucide-react'
import Hero from '../components/Hero'
import TestimonialCard from '../components/TestimonialCard'
import SEO from '../components/SEO'

export default function Testimonials() {
  const testimonials = [
    {
      name: 'Pastor Joseph Chikukwa',
      role: 'Alumni - Theology Graduate',
      program: 'Theology Program',
      image: '/assets/images/pexels-joshkjack-135018.jpg',
      quote: 'It was a long walk and there was a lot of transformation in my life, both spiritually and academically. A fruitful journey indeed, and I do not regret. The courses are structured in a way that you enjoy the work. Everything which comes will be new and interesting. The lecturers will be with you in this endeavor. As the lecturers deliver the lessons, you will be feeling great - like a fish swimming in the cool waters of the oceans. You will be enjoying the lectures, and also will be feeling the presence of the Holy Spirit. The work is Bible centered. We explored the books of the Bible, both the Old and New Testament. We did Church Planting, Homiletics, Cross Cultural Missions, Pastoral Ethics just to mention a few. I can happily say that I have already started registering my church, thanks to PISOM who gave me the confidence. To those who have a passion for God\'s word, please register with PISOM, you won\'t regret, SHALOM!'
    },
    {
      name: 'Pastor Shadaya',
      role: 'Alumni - Founding Class',
      program: 'Ministry Program',
      image: '/assets/images/pexels-rethaferguson-3825529.jpg',
      quote: 'Hallelujah Hallelujah Amen. This is a dream come true. We are so privileged as pioneers. Thank you greatly Prof Mwendesi for this positive mission. Indeed you changed lives through this Phillia School. We are now an enlightened lot. We no longer move in darkness. We have been given proper eyes to see. I\'m humbled to be part of this history-making institution. Once again hats off to you our esteemed Principal Prof Mwendesi & Dr Mwendesi. May our dear Lord bless you forevermore.'
    },
    {
      name: 'Grace Mutasa',
      role: 'Alumni, Class of 2023',
      program: 'Nursing Diploma',
      image: '/assets/images/pexels-tara-winstead-7723384.jpg',
      quote: 'The nursing program at Rudovia combined excellent clinical training with a heart for service. I\'m now working at a major hospital and making a difference in patients\' lives daily. The program prepared me well for the challenges of healthcare with both professional skills and compassionate care.'
    },
    {
      name: 'David Ncube',
      role: 'Current Student',
      program: 'Leadership Program',
      image: '/assets/images/pexels-luis-ruiz-1774931.jpg',
      quote: 'The leadership program has equipped me with practical skills and biblical wisdom. I\'m now leading youth initiatives in my church and seeing real transformation. The mentorship from faculty has been invaluable in shaping my character and leadership abilities.'
    },
    {
      name: 'Patience Chikwanha',
      role: 'Current Student',
      program: 'Theology Program',
      image: '/assets/images/pexels-cottonbro-6275777.jpg',
      quote: 'Studying at Rudovia has deepened my faith and equipped me for ministry. The biblical foundation and practical training have been life-changing. The courses start at Certificate level through Diploma and then Degree. I feel prepared to serve God\'s people with excellence and confidence.'
    },
    {
      name: 'Ministry Graduate',
      role: 'Alumni',
      program: 'Ministry Studies',
      image: '/assets/images/pexels-ian-panelo-35644053.jpg',
      quote: 'The work is not linked to any particular church or religion as other religions are also explored, such as Islam and Judaism. This comprehensive approach gave me a broader understanding of ministry and cross-cultural missions. The education I received has opened doors for effective ministry in diverse contexts.'
    }
  ]

  const successStories = [
    {
      name: 'Rev. Elizabeth Moyo',
      title: 'Senior Pastor',
      story: 'After graduating from the Theology program, Elizabeth planted a church that has grown to over 500 members. She also runs a community outreach program feeding 200 families weekly.',
      image: '/pexels-rethaferguson-3825529.jpg'
    },
    {
      name: 'Dr. James Ncube',
      title: 'Healthcare Administrator',
      story: 'James completed the Nursing Diploma and went on to earn his doctorate. He now oversees healthcare services for a network of rural clinics, improving access to quality care for thousands.',
      image: '/pexels-joshkjack-135018.jpg'
    },
    {
      name: 'Pastor Joseph Chikukwa',
      title: 'Church Planter & Pastor',
      story: 'After completing his theology studies, Pastor Joseph has successfully registered and planted his own church. His journey through the programme transformed him both spiritually and academically, equipping him with the confidence and knowledge to lead effectively.',
      image: '/pexels-tara-winstead-7723384.jpg'
    }
  ]

  return (
    <>
      <SEO 
        title="Testimonials & Success Stories - Rudovia Life College"
        description="Read inspiring testimonials from Rudovia Life College students and alumni. Discover how our programs in Theology, Leadership, Nursing, Music Ministry, and Construction Management transform lives."
        keywords="Rudovia College testimonials, student success stories, alumni testimonials, Christian education testimonials, PISOM testimonials, ministry graduate success"
      />
      <div className="pt-20">
        <Hero
          title="Testimonials & Success Stories"
          subtitle="Hear from our students and alumni about their transformative experiences"
          image="/assets/images/pexels-yentl-jacobs-43020-157811.jpg"
          height="h-[400px]"
        />

        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="text-center mb-12">
              <Star className="w-16 h-16 mx-auto mb-6 text-secondary" />
              <h2 className="heading-2 mb-4">What Our Students Say</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Real stories from real students about their journey at Rudovia Life College
              </p>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {testimonials.map((testimonial, index) => (
                <TestimonialCard key={index} {...testimonial} />
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding bg-gradient-to-r from-primary to-blue-900 text-white">
          <div className="container-custom text-center">
            <Quote className="w-16 h-16 mx-auto mb-6 text-secondary" />
            <blockquote className="text-3xl md:text-4xl font-bold mb-6 max-w-4xl mx-auto">
              "Rudovia Life College doesn't just educate—it transforms. Our graduates go on to lead churches, heal communities, design sustainable futures, and inspire change across Africa."
            </blockquote>
            <p className="text-xl text-secondary font-semibold">
              - Rev. Doc. Doreen Mwendesi, Founder
            </p>
          </div>
        </section>

        <section className="section-padding bg-gray-50">
          <div className="container-custom">
            <div className="text-center mb-12">
              <h2 className="heading-2 mb-4">Alumni Success Stories</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Our graduates are making a difference in communities across Africa and beyond
              </p>
            </div>
            <div className="space-y-12">
              {successStories.map((story, index) => (
                <div 
                  key={index} 
                  className={`grid md:grid-cols-2 gap-8 items-center ${
                    index % 2 === 1 ? 'md:flex-row-reverse' : ''
                  }`}
                >
                  <div className={index % 2 === 1 ? 'md:order-2' : ''}>
                    <img 
                      src={story.image} 
                      alt={story.name} 
                      className="rounded-2xl shadow-2xl w-full h-96 object-cover"
                    />
                  </div>
                  <div className={index % 2 === 1 ? 'md:order-1' : ''}>
                    <h3 className="text-3xl font-bold text-primary mb-2">{story.name}</h3>
                    <p className="text-secondary font-semibold text-xl mb-4">{story.title}</p>
                    <p className="text-lg text-gray-700 leading-relaxed">{story.story}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="section-padding bg-white">
          <div className="container-custom">
            <div className="bg-gradient-to-r from-secondary to-orange-600 rounded-2xl p-12 text-white text-center">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Your Success Story Starts Here</h2>
              <p className="text-xl mb-8 max-w-2xl mx-auto">
                Join hundreds of students who are transforming their lives and communities through quality Christian education at Rudovia Life College.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="/admissions" className="btn-secondary">
                  Apply Now
                </a>
                <a href="/programs" className="btn-outline border-white text-white hover:bg-white hover:text-secondary">
                  Explore Programs
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
